export default __webpack_public_path__ + "static/media/asigna.c5c191ea.svg";